module.exports = __webpack_public_path__ + "static/img/level_1.ab4134c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_1.png
// module id = HZWJ
// module chunks = 1